import { get, post } from '@/api/request.js'
import { requestData } from '@/common/js/commont.js'

// 获取联系人列表
export const getContactList = data => post('/api/warn/getContactList', requestData(data))

// 添加联系人
export const addContact = data => post('/api/warn/addContact',requestData(data))

// 删除联系人
export const deleteContact = data => post('/api/warn/delContact',requestData(data))

// 获取手机验证码
export const getMobileCode = data => post('/api/Message/getMObileCode',requestData(data))

// 获取邮箱验证码
export const getEmailCode = data => post('/api/Message/getEmailCode',requestData(data))

// 编辑联系人
export const editContact = data => post('/api/warn/editContact',requestData(data))

// 获取添加人列表
export const getAllCreator = data => post('/api/warn/getAllCreator',requestData(data))
